import script from "./SecretGame.vue?vue&type=script&setup=true&lang=js"
export * from "./SecretGame.vue?vue&type=script&setup=true&lang=js"

import "./SecretGame.vue?vue&type=style&index=0&id=104157c9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-104157c9"]])

export default __exports__